import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';

export default class UpdateAgencyUserStatusRequest extends BaseUpdateRequest {
	status: AgencyUserStatus;
}